import React from 'react';
import { find } from 'lodash';

// local dependencies
import { accessManagement as AccessManagementView } from 'ui/views/widgets/accessManagement';
import { AccessManagementService } from 'services/accessManagement';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { AccessManagement } from 'ui/containers/AccessManagement';
 *
 * // render
 * <AccessManagement propName='propValue'/>
 */
export class AccessManagement extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: {},
            selectedTab: null
        };

        this.accessManagementService = new AccessManagementService();

        this.fetchComponentData();
    }

    /**
     * Fetch widget data
     */
    fetchComponentData = async () => {
        log.debug( 'AccessManagement.fetchComponentData()' );

        this.accessManagementService.cancel();

        try {
            const { status, data } = await this.accessManagementService.fetchComponentData();

            if ( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: { tabs: data.tabs },
                    selectedTab: find( data.tabs, { config: { selected: true } } ).name
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            }
        } catch ( error ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /**
     * Handles tab change
     * @param {string} name Name of the selected tab
     */
    handleTabChange = ( name ) => {
        log.debug( 'AccessManagement.handleTabChange()' );
        
        this.setState( { selectedTab: name } );
    };

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <AccessManagementView
                { ...this.state }
                onTabChange={ this.handleTabChange }
                history={this.props.history}

            />
        );
    }
}

// set display name
AccessManagement.displayName = 'AccessManagement';

// set default props
AccessManagement.defaultProps = {};

// prop types
AccessManagement.propTypes = {};
